var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ix3mbot0a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ju507j76rb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.428 4.554c.555-.403 1.223-.611 2.135-.72v.76a1.313 1.313 0 0 0 2.625 0V3.72c.406-.002.842-.002 1.312-.002.47 0 .906 0 1.313.002v.873a1.312 1.312 0 1 0 2.624 0v-.76c.912.109 1.58.317 2.135.72.371.27.698.597.967.968.494.68.696 1.53.779 2.79H2.682c.083-1.26.285-2.11.779-2.79.27-.371.596-.698.967-.968z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.634 9.625c-.009.583-.009 1.235-.009 1.969 0 3.28 0 4.921.836 6.071.27.372.596.698.967.968 1.15.836 2.791.836 6.072.836.734 0 1.386 0 1.969-.01v-.061c0-.745 0-1.2.062-1.591a5.031 5.031 0 0 1 4.182-4.183c.392-.062.846-.062 1.591-.062h.062c.009-.582.009-1.234.009-1.968s0-1.386-.01-1.97l-.015.001H2.634z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.572 18.633c-.68.494-1.531.696-2.79.779 0-.797.002-1.13.045-1.4a3.719 3.719 0 0 1 3.091-3.091c.27-.043.603-.046 1.4-.046-.083 1.26-.285 2.11-.779 2.79-.27.372-.596.698-.967.968zM8.531 1.969a.656.656 0 1 0-1.312 0v2.625a.656.656 0 1 0 1.312 0V1.969zM13.781 1.969a.656.656 0 1 0-1.312 0v2.625a.656.656 0 1 0 1.312 0V1.969z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.719 3.313-.215.025c-.956.114-1.72.34-2.37.812-.413.3-.777.664-1.078 1.078-.578.797-.788 1.764-.873 3.052l-.035.533H18.852l-.035-.533c-.085-1.288-.294-2.255-.873-3.052a4.877 4.877 0 0 0-1.078-1.078c-.65-.473-1.414-.698-2.37-.812l-.215-.025V1.969a1.156 1.156 0 1 0-2.312 0v1.253h-.153c-.408-.003-.846-.003-1.315-.003H10.5c-.47 0-.907 0-1.315.002l-.153.001V1.97a1.156 1.156 0 1 0-2.312 0v1.344zM2.64 9.125l-.498-.006-.008.498c-.009.587-.009 1.242-.009 1.974v.033c0 1.615 0 2.868.107 3.858.11 1.007.334 1.803.824 2.477.3.414.665.778 1.079 1.079.674.49 1.47.714 2.476.823.991.108 2.244.108 3.858.108h.034c.732 0 1.387 0 1.974-.01l.492-.008V19.398c0-.761.001-1.17.056-1.513a4.531 4.531 0 0 1 3.766-3.767c.344-.054.752-.056 1.513-.056h.554l.008-.492c.009-.586.009-1.242.009-1.974v-.005c0-.732 0-1.387-.01-1.974l-.007-.498-.498.006H2.64zm10.641 10.287v.533l.533-.035c1.287-.084 2.255-.294 3.052-.872.413-.301.777-.665 1.078-1.079.579-.796.788-1.764.873-3.051l.035-.533h-.534c-.778 0-1.16.002-1.478.052a4.219 4.219 0 0 0-3.507 3.507c-.05.318-.052.7-.052 1.477z",
    stroke: "url(#auxytth0wc)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#3ucheabesd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 11.813a.656.656 0 1 0 0 1.312h5.25a.656.656 0 0 0 0-1.313h-5.25z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ju507j76rb",
    x: -22.385,
    y: -23.688,
    width: 65.769,
    height: 68.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_400_1616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_400_1616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "3ucheabesd",
    x: 4.219,
    y: 8.813,
    width: 22.563,
    height: 17.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_400_1616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_400_1616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auxytth0wc",
    x1: 2.625,
    y1: 1.313,
    x2: 20.606,
    y2: 16.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ix3mbot0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/Calendar2.c929941e66536404a0ce49a6359f9d60.svg";
export { ForwardRef as ReactComponent };